<template>
   <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
      <div class="container p-0">
        <a class="navbar-brand" href="#"><img src="images/ja-logo-edited-no-bg.png" /></a>

        <label class="hamburger navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor01"      aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
            <input type="checkbox">
            <svg viewBox="0 0 32 32">
              <path class="line line-top-bottom" d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"></path>
              <path class="line" d="M7 16 27 16"></path>
            </svg>
        </label>
        <div class="collapse navbar-collapse" id="navbarColor01">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item active home">
              <a class="nav-link" href="#">Home
                <span class="visually-hidden">(current)</span>
              </a>
            </li>
            <li class="nav-item about">
              <a class="nav-link" href="#about">About</a>
            </li>
            <li class="nav-item projects">
              <a class="nav-link" href="#projects">Projects</a>
            </li>
            <li class="nav-item contact">
              <a class="nav-link" href="#contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</template>

<style lang="scss" scoped>
@import '../assets/global.scss';

.navbar {
  padding: 10px;
  position: relative;
  width: 100%;
  transition: all 0.3s ease-in;
  justify-content: center;

  @include breakpoint('desktop') {
    position: fixed;
    z-index: 10;
  }

  &.bg-primary {
    background-color: $dark !important;
    @include breakpoint('desktop') {
      opacity: 0.9;
    }
  }
  .nav-item {
    color: $pewter;
    transition-duration: 1s;
    font-weight: bold;
    margin-right: 10px;
    &.active {
      a {
          color: white;
      }
    }
    &:hover,
    &:focus {
      color: white;
      background-color: transparent;
    }
  }
   img {
    width: 50px;
    max-height: 50px;
  }
   
  // hamburger
  .hamburger {
    cursor: pointer;
    border: 1px solid transparent;
  }
  
  .hamburger input {
    display: none;
  }
  
  .hamburger svg {
    /* The size of the SVG defines the overall size */
    height: 3em;
    /* Define the transition for transforming the SVG */
    transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .line {
    fill: none;
    stroke: white;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3;
    /* Define the transition for transforming the Stroke */
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .line-top-bottom {
    stroke-dasharray: 12 63;
  }
  
  .hamburger input:checked + svg {
    transform: rotate(-45deg);
  }
  
  .hamburger input:checked + svg .line-top-bottom {
    stroke-dasharray: 20 300;
    stroke-dashoffset: -32.42;
  }
}
</style>